import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Color } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { Modal, ModalService } from '@lsq-frontend/common-ui';
import { Regex } from '@lsq-frontend/common-ui';

@Component({
    selector: 'migrate-prospect-modal',
    styleUrls: ['./migrate-prospect-modal.component.scss'],
    template: ` <form [formGroup]="formGroup">
        <div class="formWrapper">
            <div class="text-information">
                Enter the Client Number provided by Accounting for this business and select Migrate
                User to allow the user contacts on this application to login to FastTrack AR.
                <strong
                    >These users will no longer have access to this application after this is
                    complete. This action cannot be reversed.</strong
                >
            </div>
            <div class="row">
                <div class="col-12">
                    <lsq-input
                        formControlName="clientNumber"
                        [name]="'clientNumber'"
                        label="Client Number*"
                        i18n-label="Client Number*"
                        [group]="formGroup"
                        [pattern]="alphaNumericRegex"
                    >
                    </lsq-input>
                </div>
            </div>
            <div class="migrate-error" *ngIf="formGroup.errors?.err">
                {{ formGroup.errors?.err }}
            </div>
        </div>
    </form>`
})
export class MigrateProspectModalComponent {
    public icons = Icons;
    public color = Color;
    public modal: Modal;
    public formGroup: FormGroup;
    public alphaNumericRegex = Regex.alphaNumericOnly;

    constructor(public modalService: ModalService) {
        this.formGroup = this.modalService.modal.data;
    }
}
